module.exports = __webpack_public_path__ + "media/status-error.6fabc251.svg";